import React from "react";

// Editor daftar CQ (turunan customer, mis. SLB → SLB1, SLB2) di dalam modal
// Tambah/Ubah Customer. CQ yang sudah tersimpan (CQID>0) tak bisa dihapus —
// kelak dirujuk JR/invoice — hanya dinonaktifkan; baris baru boleh dibuang.
export function validateCq(rows) {
  const seen = {};
  for (const r of rows) {
    const kode = (r.KodeCQ || "").trim();
    if (!kode) return "Kode CQ wajib diisi";
    const key = kode.toUpperCase();
    if (seen[key]) return `Kode CQ ${kode} ganda`;
    seen[key] = true;
  }
  return "";
}

// Baris baru yang benar-benar kosong diabaikan saat simpan.
export function cleanCq(rows) {
  return rows
    .filter(
      (r) => r.CQID > 0 || (r.KodeCQ || "").trim() || (r.NamaCQ || "").trim()
    )
    .map((r) => ({
      CQID: r.CQID || 0,
      KodeCQ: (r.KodeCQ || "").trim(),
      NamaCQ: (r.NamaCQ || "").trim(),
      Status: Number(r.Status) === 0 ? 0 : 1,
    }));
}

const inputCls =
  "appearance-none block w-full text-gray-700 border hover:border-gray-800 rounded py-2 px-3 leading-tight focus:outline-none bg-white";

const KlienCqEditor = ({ rows, setRows }) => {
  const update = (idx, field, value) =>
    setRows(rows.map((r, i) => (i === idx ? { ...r, [field]: value } : r)));
  const remove = (idx) => setRows(rows.filter((_, i) => i !== idx));
  const add = () =>
    setRows([...rows, { CQID: 0, KodeCQ: "", NamaCQ: "", Status: 1 }]);

  const warning = validateCq(cleanCq(rows));

  return (
    <div className="flex flex-wrap -mx-3 mb-2">
      <div className="w-full px-3">
        <label className="block uppercase tracking-wide text-gray-800 text-xs font-bold mb-2">
          CQ
        </label>
        {rows.length === 0 && (
          <p className="text-xs text-gray-500 mb-2">
            Belum ada CQ. Tambahkan bila JR/invoice customer ini perlu dipisah
            (mis. SLB1, SLB2).
          </p>
        )}
        {rows.map((r, idx) => (
          <div key={r.CQID || `new-${idx}`} className="flex gap-2 mb-2 items-center">
            <input
              className={inputCls + " w-1/3"}
              style={{ maxWidth: "8rem" }}
              type="text"
              placeholder="Kode (SLB1)"
              maxLength={30}
              value={r.KodeCQ}
              onChange={(e) => update(idx, "KodeCQ", e.target.value)}
            />
            <input
              className={inputCls}
              type="text"
              placeholder="Nama / keterangan CQ"
              value={r.NamaCQ}
              onChange={(e) => update(idx, "NamaCQ", e.target.value)}
            />
            {r.CQID > 0 ? (
              <select
                className="border rounded py-2 px-2 bg-white text-sm"
                value={Number(r.Status) === 0 ? 0 : 1}
                onChange={(e) => update(idx, "Status", Number(e.target.value))}
              >
                <option value={1}>Aktif</option>
                <option value={0}>Tidak Aktif</option>
              </select>
            ) : (
              <button
                type="button"
                title="Hapus baris"
                className="text-red-600 font-bold px-3 py-2 rounded hover:bg-red-50"
                onClick={() => remove(idx)}
              >
                ✕
              </button>
            )}
          </div>
        ))}
        {warning && <p className="text-red-500 text-xs mb-2">{warning}</p>}
        <button
          type="button"
          className="text-sm font-semibold text-green-700 border border-green-600 rounded px-3 py-1 hover:bg-green-50"
          onClick={add}
        >
          + Tambah CQ
        </button>
      </div>
    </div>
  );
};

export default KlienCqEditor;
